import { acceptPsaTerms } from '../clients/AcceptPsaTerms';
import { markProfileComplete } from '../clients/MarkProfileComplete';
import { saveWorkerClassification } from '../clients/SaveWorkerClassification';
import { SaveWorkerTypeApiError } from '../errors';
import type { ISaveWorkerTypeRequest } from '../types/SaveWorkerType';

const saveWorkerType = async (input: ISaveWorkerTypeRequest): Promise<void> => {
  try {
    // /users/worker-classification only accepts contractor/employee and does
    // NOT flip is_profile_complete on the BE. We persist is_profile_complete
    // ourselves on every path so a page refresh doesn't bounce the user back
    // to /signup/worker-type.
    if (input.workerType === 'contractor' || input.workerType === 'employee') {
      await saveWorkerClassification({ type: input.workerType });
    }
    if (input.workerType === 'employee' && input.psaAccepted) {
      await acceptPsaTerms();
    }
    await markProfileComplete();
  } catch (error) {
    const typedError = SaveWorkerTypeApiError.fromAxiosError(error);
    throw typedError ?? error;
  }
};

export const SaveWorkerTypeService = { saveWorkerType };
